import React from "react";

export function PageHeader({ eyebrow, title, subtitle, actions, testid }) {
  return (
    <div className="px-6 py-4 border-b border-slate-200 dark:border-white/10 flex flex-wrap items-center justify-between gap-4 bg-white dark:bg-[#1A2238]">
      <div>
        {eyebrow && (
          <div className="text-[10px] tracking-[0.2em] uppercase font-bold text-[#C8A24B] mb-0.5">
            {eyebrow}
          </div>
        )}
        <h1 className="text-2xl font-semibold tracking-tight text-[#0F172A] dark:text-white" data-testid={testid}>
          {title}
        </h1>
        {subtitle && <p className="text-xs text-slate-500 dark:text-gray-400 mt-1 max-w-xl leading-relaxed">{subtitle}</p>}
      </div>
      {actions && <div className="flex gap-2 items-center">{actions}</div>}
    </div>
  );
}